import { useEffect, useRef } from "react";
import { useRouter } from "next/router";

// Algolia
import { liteClient as algoliasearch } from "algoliasearch/lite";
import { autocomplete, getAlgoliaResults } from "@algolia/autocomplete-js";
import "@algolia/autocomplete-theme-classic";

const appId = "C1DGUU5BV2";
const apiKey = "cd7ead2494be9bc61a110f3e6743c08b";
const searchClient = algoliasearch(appId, apiKey);
let search;

function addSearch(algoliaRef, router) {
  if (search) {
    search.destroy();
  }

  search = autocomplete({
    container: algoliaRef.current,
    placeholder: "Search by Ingredient Name",
    detachedMediaQuery: "none",
    renderNoResults({ render, html, state }, root) {
      const pageHasForm =
        router.route === "/" || router.asPath.includes("/ingredients");
      const formLink = pageHasForm ? "#ingrdForm" : "/#ingrdForm";

      const message = pageHasForm
        ? " isn't currently included in our index. Use the “Have a question” tool to let us know."
        : " isn't currently included in our index. Use the “Have a question” tool on our homepage to let us know.";
      render(
        // html`
        //   <div class="aa-PanelLayout aa-Panel--scrollable">
        //     No results for "${state.query}".
        //   </div>
        // `,
        html`
          <div class="aa-PanelLayout aa-Panel--scrollable">
            <a href="${formLink}"> "${state.query}" ${message} </a>
          </div>
        `,
        root
      );
    },

    getSources({ query }) {
      return [
        {
          sourceId: "ingredients",
          getItems({ query }) {
            return getAlgoliaResults({
              searchClient,
              queries: [
                {
                  indexName: "aba_posts_ingredient",
                  params: {
                    query,
                    hitsPerPage: 5,
                  },
                },
              ],
            });
          },
          getItemUrl({ item }) {
            return item.permalink;
          },
          onSelect({ item, setQuery }) {
            router.push(item.permalink);
          },
          templates: {
            item({ item, components, html }) {
              return html`<div class="aa-ItemWrapper">
                <div class="aa-ItemContent">
                  <div class="aa-ItemContentBody">
                    <div class="aa-ItemContentTitle">
                      ${components.Highlight({
                        hit: item,
                        attribute: "post_title",
                      })}
                    </div>
                  </div>
                </div>
              </div>`;
            },
          },
        },
      ];
    },
    onSubmit({ state }) {
      // Select first result from list if nothing has been chosen
      if (state.activeItemId == null) {
        const collection = state.collections?.[0];
        const firstResult = collection?.items?.[0];
        if (collection.source.sourceId == "ingredients" && firstResult) {
          router.push(firstResult.permalink);
        } else {
          router.push(
            router.route === "/" || router.asPath.includes("/ingredients")
              ? "#ingrdForm"
              : "/#ingrdForm"
          );
        }
      }
    },
  });
}

export default function Searchbar(props) {
  const router = useRouter();
  const algoliaRef = useRef(null);

  useEffect(() => {
    if (!algoliaRef.current) {
      return;
    }
    addSearch(algoliaRef, router);

    // Hide btn from screen readers
    let submitBtn = document.getElementsByClassName("aa-SubmitButton");
    for (let item of submitBtn) {
      // item.setAttribute("aria-hidden", "true");
      // item.setAttribute("tabindex", "-1");
      item.setAttribute(
        "aria-label",
        "press enter to go to the first ingredient in the results list"
      );
    }
  }, []);

  return <div id="algoliaSearch" ref={algoliaRef} style={{ zIndex: 1 }} />;
}
